(() => {
  'use strict';
  if (window.BuyonikAllCatalogue) return;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const states = new WeakMap();
  let collectiveCards = null, collectiveNext = null, collectiveLoading = null;
  const labels = () => JSON.parse(document.getElementById('by-collective-labels')?.textContent || '{}');
  function collectiveSource() {
    if (collectiveCards) return collectiveCards;
    const feed = document.getElementById('by-collective-cards-template')?.content.querySelector('[data-by-collective-feed]');
    if (!feed) return [];
    collectiveCards = [...feed.querySelectorAll('[data-by-collective-card]')];
    collectiveNext = feed.dataset.next || null;
    return collectiveCards;
  }
  function addCollective(root) {
    if (root.dataset.catalogueAudience === 'merchant') return;
    const department = root.dataset.catalogueDepartment, grid = root.querySelector('[data-all-grid]');
    const known = new Set(cardsIn(root).flatMap(idsOf));
    for (const card of collectiveSource()) {
      if (department !== 'selection' && card.dataset.allCategory !== department) continue;
      if (known.has(card.dataset.productIds)) continue;
      const copy = card.cloneNode(true);
      copy.dataset.allPosition = String(grid.children.length);
      grid.append(copy);
      known.add(copy.dataset.productIds);
    }
    const present = new Set(cardsIn(root).map(card => card.dataset.allCategory || (card.hasAttribute('data-paper-card') ? 'paper' : 'health')));
    root.querySelectorAll('[data-all-filter]').forEach(button => { button.hidden = button.dataset.allFilter !== 'all' && !present.has(button.dataset.allFilter); });
    if (root.hasAttribute('data-collective-embedded')) root.hidden = grid.children.length === 0;
    const more = root.querySelector('[data-collective-more]');
    if (more) more.hidden = !collectiveNext;
    updateNavigation();
  }
  function updateNavigation() {
    const present = new Set(collectiveSource().map(card => card.dataset.allCategory)), names = labels();
    for (const nav of document.querySelectorAll('[data-by-shop-nav="consumer"] .by-shop-nav-links')) {
      for (const key of present) {
        if (['health','paper','accessories'].includes(key) || !names[key] || nav.querySelector(`[data-by-department="${key}"]`)) continue;
        const link = document.createElement('a');
        link.dataset.byDepartment = key;
        link.href = `${window.Shopify?.routes?.root || '/'}#boutiques?public=consommateur&catalogue=selection&rayon=${encodeURIComponent(key)}`;
        link.textContent = names[key];
        nav.append(link);
      }
    }
  }
  async function loadCollective(root) {
    if (!collectiveNext || collectiveLoading) return collectiveLoading;
    collectiveLoading = (async () => {
      const url = new URL(collectiveNext, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid collection origin');
      url.searchParams.set('section_id', 'by-collective-feed');
      if (root.dataset.previewTheme) url.searchParams.set('preview_theme_id', root.dataset.previewTheme);
      const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Collection unavailable');
      const feed = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-by-collective-feed]');
      if (!feed) throw new Error('Missing collection');
      collectiveCards.push(...feed.querySelectorAll('[data-by-collective-card]'));
      collectiveNext = feed.dataset.next || null;
      for (const target of document.querySelectorAll('[data-by-all-catalogue][data-all-ready]')) {
        addCollective(target);
        states.get(target).ranks = null;
        render(target);
        if (target.querySelector('[data-all-sort]').value === 'best_selling') loadRanking(target);
      }
    })();
    try { await collectiveLoading; }
    catch (_) { root.querySelector('[data-collective-message]').textContent = root.dataset.rankingError; }
    finally { collectiveLoading = null; }
  }
  const cardsIn = root => [...root.querySelector('[data-all-grid]').children];
  const idsOf = card => card.dataset.productIds?.split(',') || [...card.querySelectorAll('[data-product-id]')].map(panel => panel.dataset.productId);
  const priceOf = card => Number(card.dataset.medPrice || card.querySelector('[data-paper-panel]:not([hidden])')?.dataset.price || 0);
  function render(root) {
    const state = states.get(root);
    const category = root.querySelector('[data-all-filter][aria-pressed="true"]')?.dataset.allFilter || 'all';
    const search = normalize(root.querySelector('[data-all-search]').value);
    const order = root.querySelector('[data-all-sort]').value;
    const cards = cardsIn(root);
    let count = 0, formats = 0;
    for (const card of cards) {
      const paper = card.hasAttribute('data-paper-card');
      const panels = [...card.querySelectorAll('[data-paper-panel]')];
      const haystack = paper ? panels.map(panel => panel.dataset.search).join(' ') : card.dataset.medSearchText;
      card.hidden = !(category === 'all' || category === (card.dataset.allCategory || (paper ? 'paper' : 'health')) || (paper && category === card.dataset.paperCard)) || !!(search && !normalize(haystack).includes(search));
      if (!card.hidden) { count++; formats += paper ? panels.length : Number(card.dataset.medFormatCount); }
    }
    const original = (a, b) => Number(a.dataset.allPosition) - Number(b.dataset.allPosition);
    const rank = card => Math.min(...idsOf(card).map(id => state.ranks?.get(id) ?? Number.MAX_SAFE_INTEGER));
    cards.sort((a, b) => {
      if (order === 'price_up') return priceOf(a) - priceOf(b) || original(a, b);
      if (order === 'price_down') return priceOf(b) - priceOf(a) || original(a, b);
      if (order === 'az') return a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent, document.documentElement.lang || 'fr-CA') || original(a, b);
      if (order === 'best_selling' && state.ranks) return rank(a) - rank(b) || original(a, b);
      return original(a, b);
    });
    const grid = root.querySelector('[data-all-grid]');
    cards.forEach(card => grid.append(card));
    const counter = root.querySelector('[data-all-count]');
    counter.textContent = `${count} ${counter.dataset.results} · ${formats} ${counter.dataset.formats}`;
    root.querySelector('[data-all-empty]').hidden = count !== 0;
  }
  async function loadRanking(root) {
    const state = states.get(root), status = root.querySelector('[data-all-ranking-status]');
    if (state.ranks || state.loading) return;
    state.loading = true;
    status.hidden = false;
    status.textContent = root.dataset.rankingLoading;
    try {
      const ranks = new Map(), wanted = new Set(cardsIn(root).flatMap(idsOf));
      let url = new URL(root.dataset.rankingUrl, location.origin), page = 0;
      while (url && wanted.size && page < 100) {
        if (url.origin !== location.origin) throw new Error('Invalid ranking origin');
        url.searchParams.set('sort_by', 'best-selling');
        url.searchParams.set('section_id', 'by-catalogue-ranking');
        if (root.dataset.previewTheme) url.searchParams.set('preview_theme_id', root.dataset.previewTheme);
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 10000);
        let response, html;
        try {
          response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Ranking unavailable');
          html = await response.text();
        } finally { clearTimeout(timer); }
        const payload = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-by-catalogue-ranking]');
        if (!payload) throw new Error('Missing ranking');
        const data = JSON.parse(payload.textContent);
        if (data.sort !== 'best-selling' || !Array.isArray(data.ids)) throw new Error('Invalid ranking');
        for (const id of data.ids.map(String)) { if (!ranks.has(id)) ranks.set(id, ranks.size); wanted.delete(id); }
        url = data.next ? new URL(data.next, url) : null;
        page++;
      }
      if (wanted.size) throw new Error('Incomplete ranking');
      state.ranks = ranks;
      status.hidden = true;
      render(root);
    } catch (_) {
      const select = root.querySelector('[data-all-sort]');
      if (select.value === 'best_selling') {
        select.value = 'selection';
        status.textContent = root.dataset.rankingError;
        status.hidden = false;
        render(root);
      } else { status.hidden = true; }
    } finally { state.loading = false; }
  }
  function init() {
    document.querySelectorAll('[data-by-all-catalogue]:not([data-all-ready])').forEach(root => {
      const merchant = root.dataset.catalogueAudience === 'merchant';
      const includeHealth = !merchant && root.dataset.catalogueDepartment === 'selection';
      if (includeHealth && !window.BuyonikMedelys?.renderCards) return;
      root.dataset.allReady = 'true';
      states.set(root, { ranks: null, loading: false });
      if (includeHealth) root.querySelector('[data-all-grid]').insertAdjacentHTML('afterbegin', window.BuyonikMedelys.renderCards());
      cardsIn(root).forEach((card, index) => { card.dataset.allPosition = String(index); });
      addCollective(root);
      const requested = new URLSearchParams(location.hash.split('?')[1] || '').get('rayon');
      if (root.dataset.catalogueDepartment === 'selection' && requested) {
        const chosen = [...root.querySelectorAll('[data-all-filter]')].find(button => button.dataset.allFilter === requested && !button.hidden);
        if (chosen) root.querySelectorAll('[data-all-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === chosen)));
      }
      render(root);
      if (root.querySelector('[data-all-sort]').value === 'best_selling') loadRanking(root);
    });
  }
  document.addEventListener('click', event => {
    const variantButton = event.target.closest('[data-by-card-variant]');
    if (variantButton) {
      const card = variantButton.closest('[data-by-collective-card]');
      if (!card || card.querySelector('form[aria-busy="true"]')) return;
      const selected = variantButton.dataset;
      card.querySelectorAll('[data-by-card-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variantButton)));
      card.querySelectorAll('[data-by-card-link]').forEach(link => { link.href = selected.variantUrl; });
      card.dataset.medPrice = selected.variantPrice;
      card.querySelector('[data-by-card-price]').innerHTML = selected.variantMoney;
      const form = card.querySelector('form[data-by-ajax-add]');
      if (form) {
        form.querySelector('input[name="id"]').value = selected.byCardVariant;
        form.querySelector('input[name="quantity"]').value = selected.variantMin;
        const add = form.querySelector('[data-by-card-add]');
        add.disabled = selected.variantAvailable !== 'true';
        add.textContent = add.disabled ? add.dataset.unavailableLabel : add.dataset.addLabel;
      }
      const image = card.querySelector('.by-med-card-visual img');
      if (image && selected.variantImage) {
        image.removeAttribute('srcset');
        image.src = selected.variantImage;
        image.alt = selected.variantAlt || '';
      }
      const stock = card.querySelector('[data-by-card-stock]');
      const stockTemplate = [...card.querySelectorAll('[data-by-card-stock-for]')].find(template => template.dataset.byCardStockFor === selected.byCardVariant);
      if (stock && stockTemplate) stock.replaceChildren(stockTemplate.content.cloneNode(true));
      const root = card.closest('[data-by-all-catalogue]');
      if (root && states.has(root)) render(root);
      card.dispatchEvent(new CustomEvent('buyonik:format-change', { bubbles: true }));
      return;
    }
    const loadButton = event.target.closest('[data-collective-load]');
    if (loadButton) { loadCollective(loadButton.closest('[data-by-all-catalogue]')); return; }
    const button = event.target.closest('[data-all-filter], [data-all-reset]');
    if (!button) return;
    const root = button.closest('[data-by-all-catalogue]'), reset = button.hasAttribute('data-all-reset');
    root.querySelectorAll('[data-all-filter]').forEach(item => item.setAttribute('aria-pressed', String(reset ? item.dataset.allFilter === 'all' : item === button)));
    if (reset) root.querySelector('[data-all-search]').value = '';
    render(root);
  });
  document.addEventListener('input', event => { if (event.target.matches('[data-all-search]')) render(event.target.closest('[data-by-all-catalogue]')); });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-all-sort]')) return;
    const root = event.target.closest('[data-by-all-catalogue]');
    root.querySelector('[data-all-ranking-status]').hidden = true;
    render(root);
    if (event.target.value === 'best_selling') loadRanking(root);
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
  window.BuyonikAllCatalogue = { init };
  init();
})();


